import React from 'react';

const Handball = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='Handball' transform='translate(-53.678 -292.505)'>
                <path
                    id='Path_3097'
                    data-name='Path 3097'
                    d='M62.177,298.932c-.636-.008-1.307-.015-2-.019,0-.105.007-.212.012-.316.008-.178.016-.361.017-.544,0-.148,0-.3,0-.444.006-.536.01-1.089-.012-1.636a4.895,4.895,0,0,0-.459-1.885,2.765,2.765,0,0,0-1.309-1.392l.869-.168.1-.019.023,0h.955l.274.042c.224.034.455.069.679.111.117.022.237.055.353.086.085.023.172.047.258.068a1.327,1.327,0,0,1,.775.635,3.932,3.932,0,0,1,.358,3.4,8.643,8.643,0,0,1-.9,2.073Z'
                    transform='translate(0.793)'
                />
                <path
                    id='Path_3098'
                    data-name='Path 3098'
                    d='M63.971,301.985A6.115,6.115,0,0,1,62,301.62a10.073,10.073,0,0,1-2.029-.985l-.007-.007c-.013-.491-.018-.99-.023-1.472l0-.153h.031l.247,0c.11,0,.2,0,.286,0,.31.013.615.019.905.019a16.889,16.889,0,0,0,1.914-.1,5.427,5.427,0,0,0,2.078-.6,2.6,2.6,0,0,0,1.073-1.036c.034.176.066.355.1.531.021.121.033.25.046.375v.006c0,.055.01.11.016.163v.616c-.013.1-.024.2-.036.3-.026.228-.054.462-.091.69a2.62,2.62,0,0,1-.457,1.245,2.018,2.018,0,0,1-1.292.7A4.291,4.291,0,0,1,63.971,301.985Z'
                    transform='translate(1.043 0.797)'
                />
                <path
                    id='Path_3099'
                    data-name='Path 3099'
                    d='M53.818,300.389c-.016-.073-.032-.147-.047-.221-.029-.142-.049-.293-.068-.44-.008-.065-.016-.13-.026-.194v-.962c.015-.1.029-.2.044-.307v0c.034-.243.069-.495.116-.736a6.013,6.013,0,0,1,.221-.852,1.654,1.654,0,0,1,.9-.916,2.974,2.974,0,0,1,1.317-.278h.153a7.533,7.533,0,0,1,3.336.857c.055.027.111.057.166.086.076.04.154.082.237.12-.017.452-.031.905-.045,1.345,0,0-.012.343-.016.495l-.132-.006c-.25-.013-.509-.027-.765-.042-.322-.019-.7-.039-1.092-.039a6.443,6.443,0,0,0-2.408.4,3.109,3.109,0,0,0-1.826,1.548C53.859,300.29,53.838,300.339,53.818,300.389Z'
                    transform='translate(0 0.496)'
                />
                <path
                    id='Path_3100'
                    data-name='Path 3100'
                    d='M60.17,305.481a6.794,6.794,0,0,1-1.89-.268,1.139,1.139,0,0,1-.422-.231,3.39,3.39,0,0,1-1.224-1.887,4.654,4.654,0,0,1,.106-2.077A12.71,12.71,0,0,1,57.5,298.9l.016-.035c.011-.021.022-.047.034-.075.021-.053.037-.1.05-.131l.006-.015c.028,0,.064,0,.106,0l.076,0,1.824.082v.06c0,.2,0,.383,0,.574a15.3,15.3,0,0,0,.3,3.239,4.766,4.766,0,0,0,.762,1.821,2.593,2.593,0,0,0,1.07.876c-.1.023-.2.044-.306.062A7.458,7.458,0,0,1,60.17,305.481Z'
                    transform='translate(0.48 1.024)'
                />
                <path
                    id='Path_3101'
                    data-name='Path 3101'
                    d='M62.258,304.232a2.155,2.155,0,0,1-.561-.069,1.726,1.726,0,0,1-1.069-.917,5.557,5.557,0,0,1-.554-1.847c-.016-.111-.03-.222-.043-.337a9.157,9.157,0,0,0,2.962,1.078,6.754,6.754,0,0,0,1.089.1,4.184,4.184,0,0,0,1.287-.189c-.1.147-.208.294-.317.434a6.546,6.546,0,0,1-1.674,1.508,1.359,1.359,0,0,1-.589.2A4.59,4.59,0,0,1,62.258,304.232Z'
                    transform='translate(1.059 1.426)'
                />
                <path
                    id='Path_3102'
                    data-name='Path 3102'
                    d='M62.534,298.683c.072-.142.14-.28.2-.422a7.679,7.679,0,0,0,.726-2.564,4.662,4.662,0,0,0-.266-2.116c.084.058.167.117.246.177a6.882,6.882,0,0,1,1.8,2.032,1.76,1.76,0,0,1,.187,1.216,1.593,1.593,0,0,1-.747,1.075,4.521,4.521,0,0,1-1.75.555C62.806,298.653,62.672,298.668,62.534,298.683Z'
                    transform='translate(1.476 0.179)'
                />
                <path
                    id='Path_3103'
                    data-name='Path 3103'
                    d='M56.433,304.129a5.74,5.74,0,0,1-.846-.737c-.169-.178-.344-.379-.554-.629a2.957,2.957,0,0,1-.666-1.8,1.762,1.762,0,0,1,.812-1.611,4.037,4.037,0,0,1,1.81-.65c-.056.131-.111.259-.162.389a10.655,10.655,0,0,0-.747,2.626A4.15,4.15,0,0,0,56.433,304.129Z'
                    transform='translate(0.114 1.033)'
                />
                <path
                    id='Path_3104'
                    data-name='Path 3104'
                    d='M59.932,295.925c-.14-.068-.277-.131-.417-.192a8.153,8.153,0,0,0-3.291-.75h-.018a4.67,4.67,0,0,0-1.317.176,4.935,4.935,0,0,1,.656-.73,13.2,13.2,0,0,1,1.252-1.006,1.462,1.462,0,0,1,.881-.24,3.819,3.819,0,0,1,.431.028,1.687,1.687,0,0,1,1.269.837A4.109,4.109,0,0,1,59.932,295.925Z'
                    transform='translate(0.202 0.113)'
                />
            </g>
        </svg>
    );
};

export default Handball;
